/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  CompanyWithUsers,
  CompanyWithUsersVariables,
  CompanyWithUsers_company_Company_usersRoles_UserRole as UserRole,
  CompanyWithUsers_company_Company_invitations_Invitation as Invitation,
  CompanyWithUsers_company_Company_subregion_Subregion as Subregion,
  CompanyWithUsers_company_Company_usersRoles_UserRole_user_User_organizationRole_OrganizationRole as CompanyUserOrganizationRole,
} from './types/index.graphql'
export type { LeaveCompany, LeaveCompanyVariables } from './types/index.graphql'
export type { ChangeUserRole, ChangeUserRoleVariables } from './types/index.graphql'
export type { InviteUser, InviteUserVariables } from './types/index.graphql'
export type {
  ResendCompanyInvitation,
  ResendCompanyInvitationVariables,
} from './types/index.graphql'

export const COMPANY_WITH_USERS = gql`
  query CompanyWithUsers($id: Int!) {
    company(id: $id) {
      id
      name
      logo
      governmentId
      irrigationWorkersAccessMode
      phoneNumber
      subregion {
        id
        region {
          id
          name
        }
      }
      organization {
        id
      }
      country {
        id
      }
      usersRoles {
        role
        user {
          id
          email
          name
          lastName
          isVerified
          profilePicture
          organizationRole {
            role
          }
        }
      }
      invitations {
        id
        email
        role
      }
    }
  }
`

export const LEAVE_COMPANY = gql`
  mutation LeaveCompany($companyId: Int!, $userId: Int!) {
    leaveCompany(companyId: $companyId, userId: $userId) {
      user {
        id
        email
        companiesRoles {
          role
          company {
            id
            name
            country {
              id
              lng
              code
            }
          }
        }
      }
    }
  }
`

export const CHANGE_USER_ROLE = gql`
  mutation ChangeUserRole($userId: Int!, $companyId: Int!, $role: UserCompanyRole!) {
    changeUserRole(userId: $userId, companyId: $companyId, role: $role) {
      company {
        id
        name
        usersRoles {
          role
          user {
            id
            email
          }
        }
      }
    }
  }
`

export const INVITE_USER = gql`
  mutation InviteUser($inviteUserDTO: InviteUserInput!) {
    inviteUser(inviteUserDTO: $inviteUserDTO) {
      company {
        id
        name
        usersRoles {
          role
          user {
            id
            email
          }
        }
        invitations {
          id
          email
          role
        }
      }
    }
  }
`

export const RESEND_COMPANY_INVITATION = gql`
  mutation ResendCompanyInvitation($id: Int!) {
    resendInvitation(id: $id) {
      success
    }
  }
`
